

function populateProcladDrawerCards() {
  const shell = document.querySelector('.proclad-drawer-cards');
  const row = shell?.querySelector('.proclad-drawer-cards__row');
  if (!shell || !row || row.childElementCount > 0) return;

  const source = document.querySelector('.proclad-mega-cards');
  const cards = source ? source.querySelectorAll('.proclad-mega-card') : [];
  if (!cards.length) return;

  for (const card of cards) row.appendChild(card.cloneNode(true));
  shell.hidden = false;
}

function syncProcladDrawerTop() {
  const drawer = document.querySelector('#header-component .menu-drawer');
  const header = document.querySelector('#header-component .header') || document.querySelector('#header-component');
  if (!drawer || !header) return;
  const bottom = Math.max(0, header.getBoundingClientRect().bottom);
  drawer.style.top = bottom + 'px';
  drawer.style.height = 'calc(100dvh - ' + bottom + 'px)';
}

document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;
    const summary = event.target.closest('summary.header__icon--menu');
    if (!summary) return;

    populateProcladDrawerCards();
    const details = summary.closest('details');
    if (!details) return;

    if (!details.hasAttribute('open')) {
      syncProcladDrawerTop();
    }
  },
  true
);

populateProcladDrawerCards();
document.addEventListener('DOMContentLoaded', populateProcladDrawerCards);
document.addEventListener('shopify:section:load', populateProcladDrawerCards);
